module.exports = __webpack_public_path__ + "img/tarjeta_servicios_seguro_salud.3c7ef4ab.jpg";